import { createContext, useContext, useState } from 'react';

export const NavigationContext = createContext({
  sideNavOpen: false,
  toggleSideNav: () => {},
});

const NavigationProvider = ({ children }) => {
  const [sideNavOpen, setOpen] = useState(false);

  const toggleSideNav = () => setOpen(!sideNavOpen);

  return (
    <NavigationContext.Provider value={{ toggleSideNav, sideNavOpen }}>
      {children}
    </NavigationContext.Provider>
  );
};

export default NavigationProvider;

export const useNavContext = () => useContext(NavigationContext);
